let API_BASE = "/api";

export class BookingPathConstants {
  public static PAGE_BOOKING_PATH = "/booking/paths/:bookingId";
}
